import gql from 'graphql-tag';
import { paycheckFormFragment } from './paycheckFragments';

export const PAYCHECKS_SEARCH = gql`
  query paychecksSearch(
    $limit: Int,
    $offset: Int,
    $orderBy: String,
    $orderDirection: String,
    $filters: PaycheckFilter
  ) {
    paychecks(
      limit: $limit,
      offset: $offset,
      orderBy: $orderBy,
      orderDirection: $orderDirection,
      filters: $filters
    ) {
      id
      number
      journalDate
      startDate
      endDate
      employeeName
      paidDate
      shouldSendToAltinn
      reportedDate
      locked
      advancedMode
    }
  },
`;

export const GET_PAYCHECK = gql`
  query paycheckForm($id: ID!) {
    paycheck(id: $id) {
      ...paycheckFormFragment,
    }
  }
  ${paycheckFormFragment}
`;

export const PAYCHECK_PDF = gql`
  query paycheckPdf($id: ID!) {
    paycheck(id: $id) {
      id
      pdf {
        id
        url
      }
    }
  }
`;
